import { useEffect, useState } from 'react';
import { apiFetch } from '@/lib/api';

// The media endpoint now requires a bearer token, which <img>/<video> src
// attributes can't send — fetch the bytes ourselves and expose a blob URL.
export function useAuthenticatedMedia(jobId: string | undefined, ready: boolean): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!jobId || !ready) return;

    let objectUrl: string | null = null;
    let cancelled = false;

    (async () => {
      const response = await apiFetch(`/api/jobs/${jobId}/media`);
      if (!response.ok || cancelled) return;
      const blob = await response.blob();
      objectUrl = URL.createObjectURL(blob);
      if (!cancelled) setUrl(objectUrl);
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [jobId, ready]);

  return url;
}
